import { Row } from 'antd';
import styled from 'styled-components';

export const PeopleSectionHeader = styled.span`
  font-size: 15px;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a8};
  display: flex;
  width: 100%;
`;

export const StyledRow = styled(Row)`
  width: 100%;
`;

export const SectionPart = styled.div`
  flex-grow: 1;
`;

export const TitleContainer = styled.span`
  display: flex;
  margin: 0 15px;
  text-align: left;
  align-items: center;
  min-width: 255px;
  flex-grow: 1;
`;

export const ToggleWrapper = styled.span`
  margin-left: 10px;
  align-items: center;
`;

export const SelectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-left: 10px;

  .label {
    color: ${({ theme }) => theme.baseBlue.a8};
  }
`;

export const SelectionSubtitle = styled.span`
  margin-left: 25px;
  font-size: 12px;
  line-height: 1.83;
  margin-bottom: 10px;
`;

export const SecondPeopleSectionBottom = styled.span`
  display: flex;
  flex-direction: row;
  height: 43px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;

  svg {
    color: ${({ theme }) => theme.baseBlue.a6};
  }
`;

export const ModalHeader = styled.div`
  font-size: 21px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
`;

export const ModalSubHeader = styled.div`
  font-size: 15px;
  line-height: 1.73;
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const ModalSectionContainer = styled.div`
  padding: 14px 60px;
`;

export const ModalButtonSectionContainer = styled.div`
  display: flex;
  justify-content: center;
  button {
    margin: 0 7px;
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ChipDescription = styled.span`
  display: flex;
  flex-direction: column;
`;